"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkCkbTxInputsCapacitySufficient = exports.isScriptEqual = exports.deduplicateList = exports.calculateCellOccupiedCapacity = exports.calculateRgbppSporeCellCapacity = exports.calculateRgbppClusterCellCapacity = exports.generateUniqueTypeArgs = exports.calculateRgbppTokenInfoCellCapacity = exports.calculateXudtTokenInfoCellCapacity = exports.calculateUdtCellCapacity = exports.calculateRgbppCellCapacity = exports.isLockArgsSizeExceeded = exports.isTypeAssetSupported = exports.isClusterSporeTypeSupported = exports.isSporeTypeSupported = exports.isUDTTypeSupported = exports.calculateTransactionFee = void 0;
const core_1 = require("@spore-sdk/core");
const hex_1 = require("./hex");
const constants_1 = require("../constants");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const rgbpp_1 = require("./rgbpp");
const error_1 = require("../error");
const calculateTransactionFee = (txSize, feeRate) => {
    const rate = feeRate !== null && feeRate !== void 0 ? feeRate : BigInt(1100);
    const ratio = BigInt(1000);
    const base = BigInt(txSize) * rate;
    const fee = base / ratio;
    return fee * ratio < base ? fee + BigInt(1) : fee;
};
exports.calculateTransactionFee = calculateTransactionFee;
const isUDTTypeSupported = (type, isMainnet) => {
    const xudtType = (0, ckb_sdk_utils_1.serializeScript)((0, constants_1.getXudtTypeScript)(isMainnet));
    const typeAsset = (0, ckb_sdk_utils_1.serializeScript)(Object.assign(Object.assign({}, type), { args: '' }));
    return xudtType === typeAsset;
};
exports.isUDTTypeSupported = isUDTTypeSupported;
const isSporeTypeSupported = (type, isMainnet) => {
    const sporeType = (0, ckb_sdk_utils_1.serializeScript)((0, constants_1.getSporeTypeScript)(isMainnet));
    const typeAsset = (0, ckb_sdk_utils_1.serializeScript)(Object.assign(Object.assign({}, type), { args: '' }));
    return sporeType === typeAsset;
};
exports.isSporeTypeSupported = isSporeTypeSupported;
const isClusterSporeTypeSupported = (type, isMainnet) => {
    const typeAsset = (0, ckb_sdk_utils_1.serializeScript)(Object.assign(Object.assign({}, type), { args: '' }));
    const clusterType = (0, ckb_sdk_utils_1.serializeScript)((0, constants_1.getClusterTypeScript)(isMainnet));
    return (0, exports.isSporeTypeSupported)(type, isMainnet) || clusterType === typeAsset;
};
exports.isClusterSporeTypeSupported = isClusterSporeTypeSupported;
const isTypeAssetSupported = (type, isMainnet) => {
    return (0, exports.isUDTTypeSupported)(type, isMainnet) || (0, exports.isClusterSporeTypeSupported)(type, isMainnet);
};
exports.isTypeAssetSupported = isTypeAssetSupported;
const CELL_CAPACITY_SIZE = 8;
const UDT_CELL_DATA_SIZE = 16;
// Assume the length of the lock script args cannot exceed 26 bytes. If it exceeds, an error will be thrown.
const LOCK_ARGS_HEX_MAX_SIZE = 26;
const isLockArgsSizeExceeded = (args) => (0, hex_1.remove0x)(args).length > LOCK_ARGS_HEX_MAX_SIZE * 2;
exports.isLockArgsSizeExceeded = isLockArgsSizeExceeded;
// The BTC_TIME_CELL_INCREASED_SIZE depends on the receiver lock script args whose length cannot exceed LOCK_ARGS_HEX_MAX_SIZE bytes
const BTC_TIME_CELL_INCREASED_SIZE = 95;
// For simplicity, we keep the capacity of the RGBPP cell the same as the BTC time cell
// minimum occupied capacity and 1 ckb for transaction fee and assume UDT cell data size is 16bytes
/**
 * RGB_lock:
    code_hash:
      RGB_lock
    args:
      out_index | bitcoin_tx_id
 */
const RGBPP_LOCK_SIZE = 32 + 1 + 36;
const calculateRgbppCellCapacity = (xudtType) => {
    const typeArgsSize = xudtType ? (0, hex_1.remove0x)(xudtType.args).length / 2 : 32;
    const udtTypeSize = 33 + typeArgsSize;
    const cellSize = RGBPP_LOCK_SIZE + udtTypeSize + CELL_CAPACITY_SIZE + UDT_CELL_DATA_SIZE + BTC_TIME_CELL_INCREASED_SIZE;
    return BigInt(cellSize + 1) * constants_1.CKB_UNIT;
};
exports.calculateRgbppCellCapacity = calculateRgbppCellCapacity;
// Minimum occupied capacity and 1 ckb for transaction fee
// Assume UDT cell data size is 16bytes
// The default length of xut type args is 32 bytes
const DEFAULT_UDT_ARGS_SIZE = 32;
const calculateUdtCellCapacity = (lock, udtType) => {
    const lockArgsSize = (0, hex_1.remove0x)(lock.args).length / 2;
    const typeArgsSize = udtType ? (0, hex_1.remove0x)(udtType.args).length / 2 : DEFAULT_UDT_ARGS_SIZE;
    const lockSize = 33 + lockArgsSize;
    const typeSize = 33 + typeArgsSize;
    const cellSize = lockSize + typeSize + CELL_CAPACITY_SIZE + UDT_CELL_DATA_SIZE;
    return BigInt(cellSize + 1) * constants_1.CKB_UNIT;
};
exports.calculateUdtCellCapacity = calculateUdtCellCapacity;
// Unique Type Script: https://github.com/ckb-cell/unique-cell?tab=readme-ov-file#unique-type-script
const calculateXudtTokenInfoCellCapacity = (tokenInfo, lock) => {
    const lockSize = (0, hex_1.remove0x)(lock.args).length / 2 + 33;
    const cellDataSize = (0, hex_1.remove0x)((0, rgbpp_1.encodeRgbppTokenInfo)(tokenInfo)).length / 2;
    const uniqueTypeSize = 32 + 1 + 20;
    const cellSize = lockSize + uniqueTypeSize + CELL_CAPACITY_SIZE + cellDataSize;
    return BigInt(cellSize) * constants_1.CKB_UNIT;
};
exports.calculateXudtTokenInfoCellCapacity = calculateXudtTokenInfoCellCapacity;
// Unique Type Script: https://github.com/ckb-cell/unique-cell?tab=readme-ov-file#unique-type-script
const calculateRgbppTokenInfoCellCapacity = (tokenInfo, isMainnet) => {
    const btcTimeLock = (0, rgbpp_1.genBtcTimeLockScript)(constants_1.UNLOCKABLE_LOCK_SCRIPT, isMainnet);
    const lockSize = (0, hex_1.remove0x)(btcTimeLock.args).length / 2 + 33;
    const cellDataSize = (0, hex_1.remove0x)((0, rgbpp_1.encodeRgbppTokenInfo)(tokenInfo)).length / 2;
    const typeSize = 32 + 1 + 20;
    const cellSize = lockSize + typeSize + CELL_CAPACITY_SIZE + cellDataSize;
    return BigInt(cellSize) * constants_1.CKB_UNIT;
};
exports.calculateRgbppTokenInfoCellCapacity = calculateRgbppTokenInfoCellCapacity;
// Generate type id for Unique type script args
const generateUniqueTypeArgs = (firstInput, firstOutputIndex) => {
    const input = (0, ckb_sdk_utils_1.hexToBytes)((0, ckb_sdk_utils_1.serializeInput)(firstInput));
    const s = (0, ckb_sdk_utils_1.blake2b)(32, null, null, ckb_sdk_utils_1.PERSONAL);
    s.update(input);
    s.update((0, ckb_sdk_utils_1.hexToBytes)(`0x${(0, hex_1.u64ToLe)(BigInt(firstOutputIndex))}`));
    return `0x${s.digest('hex').slice(0, 40)}`;
};
exports.generateUniqueTypeArgs = generateUniqueTypeArgs;
// https://docs.spore.pro/recipes/Create/create-private-cluster
// Minimum occupied capacity and 1 ckb for transaction fee
const calculateRgbppClusterCellCapacity = (clusterData) => {
    const clusterDataSize = (0, core_1.packRawClusterData)(clusterData).length;
    const clusterTypeSize = 32 + 1 + 32;
    const cellSize = RGBPP_LOCK_SIZE + clusterTypeSize + CELL_CAPACITY_SIZE + clusterDataSize;
    return BigInt(cellSize + 1) * constants_1.CKB_UNIT;
};
exports.calculateRgbppClusterCellCapacity = calculateRgbppClusterCellCapacity;
// https://docs.spore.pro/recipes/Create/create-clustered-spore
// For simplicity, we keep the capacity of the RGBPP cell the same as the BTC time cell
// minimum occupied capacity and 1 ckb for transaction fee
/**
 * rgbpp_spore_cell:
    lock: rgbpp_lock
    type: spore_type
    data: sporeData
 */
const calculateRgbppSporeCellCapacity = (sporeData) => {
    const sporeDataSize = (0, core_1.packRawSporeData)(sporeData).length;
    const sporeTypeSize = 32 + 1 + 32;
    const cellSize = RGBPP_LOCK_SIZE + sporeTypeSize + CELL_CAPACITY_SIZE + sporeDataSize + BTC_TIME_CELL_INCREASED_SIZE;
    return BigInt(cellSize + 1) * constants_1.CKB_UNIT;
};
exports.calculateRgbppSporeCellCapacity = calculateRgbppSporeCellCapacity;
// Calculate the occupied capacity of the CKB cell
const calculateCellOccupiedCapacity = (cell) => {
    const cellDataSize = (0, hex_1.remove0x)(cell.outputData).length / 2;
    const lockSize = (0, hex_1.remove0x)(cell.output.lock.args).length / 2 + 1 + 32;
    const typeSize = cell.output.type ? (0, hex_1.remove0x)(cell.output.type.args).length / 2 + 1 + 32 : 0;
    const cellSize = cellDataSize + lockSize + typeSize + CELL_CAPACITY_SIZE;
    return BigInt(cellSize) * constants_1.CKB_UNIT;
};
exports.calculateCellOccupiedCapacity = calculateCellOccupiedCapacity;
const deduplicateList = (rgbppLockArgsList) => {
    return Array.from(new Set(rgbppLockArgsList));
};
exports.deduplicateList = deduplicateList;
// Compare the whole script
const isScriptEqual = (s1, s2) => {
    const temp1 = typeof s1 === 'string' ? (0, hex_1.remove0x)(s1) : (0, hex_1.remove0x)((0, ckb_sdk_utils_1.serializeScript)(s1));
    const temp2 = typeof s2 === 'string' ? (0, hex_1.remove0x)(s2) : (0, hex_1.remove0x)((0, ckb_sdk_utils_1.serializeScript)(s2));
    return temp1 === temp2;
};
exports.isScriptEqual = isScriptEqual;
/**
 * Check whether the capacity of inputs is sufficient for outputs
 * @param ckbTx CKB raw transaction
 * @param collector The collector that collects CKB live cells and transactions
 * @returns When the capacity of inputs is sufficient for outputs, return true, otherwise return false
 */
const checkCkbTxInputsCapacitySufficient = (ckbTx, collector) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, e_1, _b, _c;
    let sumInputsCapacity = BigInt(0);
    try {
        for (var _d = true, _e = __asyncValues(ckbTx.inputs), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
            _c = _f.value;
            _d = false;
            const input = _c;
            const liveCell = yield collector.getLiveCell(input.previousOutput);
            if (!liveCell) {
                throw new error_1.NoLiveCellError('The cell with the specific out point is dead');
            }
            sumInputsCapacity += BigInt(liveCell.output.capacity);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    const sumOutputsCapacity = ckbTx.outputs
        .map((output) => BigInt(output.capacity))
        .reduce((prev, current) => prev + current, BigInt(0));
    return sumInputsCapacity > sumOutputsCapacity;
});
exports.checkCkbTxInputsCapacitySufficient = checkCkbTxInputsCapacitySufficient;
